import { render, staticRenderFns } from "./YearStats.vue?vue&type=template&id=5718b2fe&lang=pug&"
import script from "./YearStats.vue?vue&type=script&lang=ts&"
export * from "./YearStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports